import React, { useContext, useState } from 'react';
import { Pills, Tabs } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { NewPage } from 'core/components';
import { PillGroupIds, PILLS_GROUP_CONFIG, TabGroupIds, TABS_GROUPS_CONFIG } from '../tabs/groupConfig';
import { GroupCessionList } from 'features/brazil-grower/components/GroupCessionList/GroupCessionList';
import { UserContext } from 'core/components/GateWay/GateWay';
import { GroupListsFilterCriteria, localStorageUtils } from 'shared';

export const CessionGroupsListPage: React.FunctionComponent = () => {
  /**
   * context
   */
  const { isCreditAnalyst, isCreditLead, isSuper } = useContext(UserContext);

  const tabConfig = TABS_GROUPS_CONFIG.cession;
  const pillsConfig =
    isSuper || isCreditAnalyst || isCreditLead
      ? PILLS_GROUP_CONFIG[TabGroupIds.CESSION_TO_FUND]
      : PILLS_GROUP_CONFIG[TabGroupIds.CESSION_TO_FUND].filter(
          ({ id }: { id: PillGroupIds }) => id !== PillGroupIds.RECEIVED_BY_FUND && id !== PillGroupIds.CESSION_ASSIGNED
        );

  /**
   * states
   */
  const [activeTab] = useState(TabGroupIds.CESSION_TO_FUND);
  const [activePill, setActivePill] = useState<PillGroupIds>(
    (localStorageUtils.get(GroupListsFilterCriteria.ACTIVE_GROUP_PILL) as PillGroupIds) || [...pillsConfig].shift()?.id
  );

  /**
   * callbacks
   */
  const updateSelectedPill = (newPill: PillGroupIds): void => {
    setActivePill(newPill);
  };

  return (
    <NewPage title={i18next.t('cessions')}>
      {activeTab && !!tabConfig.length && (
        <Tabs
          activeTabId={activeTab}
          ariaLabel="Groups assignments"
          items={tabConfig}
          onChange={Function}
          className="mb32"
        />
      )}
      <div className="flex mb32">
        <Pills
          activePillId={activePill}
          ariaLabel="AgFinancing Assignments group table"
          items={pillsConfig}
          onChange={updateSelectedPill}
        />
      </div>
      <GroupCessionList activePill={activePill} activeTab={activeTab} />
    </NewPage>
  );
};
